import HttpClient from "../commons/HttpClient.js";

const visitorsEndpoint = "/api/visitors";


class VisitorsClient extends HttpClient {

    constructor(host, apiKey) {
        super();
        this._apiKey = apiKey;
        this._host = host;
    }


    async create(data){
        
        let url = this._host + visitorsEndpoint;

        let headers = {
            'Content-Type': 'application/json'
        };
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";

        return this.makeRequest(url, "POST", data, headers);
    }

    async partialUpdate(data) {
        let url = this._host + visitorsEndpoint;
        let headers = {
            'Content-Type': 'application/json'
        };
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        headers['X-API-KEY'] = this._apiKey;
        headers['X-DEVICE-ID'] = "aa=";
        return this.makeRequest(url, "PATCH", data, headers);
    }

    async fetchAllOfPage(query) {
        
        if (!('page' in query))
            query.page = 1;
        
        if (!('size' in query))
            query.size = 20;

        let url = this.getUrl(this._host + visitorsEndpoint, query);
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        
        return this.makeRequest(
            url,
            "GET",
            {},
            headers
        );
    }

    deleteVisitor(id) {
        

        let url = this.getUrl(this._host + visitorsEndpoint, { id: id });
        let headers = {
            'Content-Type': 'application/json'
        };
        headers["X-API-KEY"] = this._apiKey;
        headers["X-DEVICE-ID"] = "aa=";
        if (localStorage.getItem('token')) {
            headers['X-AUTH-TOKEN'] = localStorage.getItem('token');
        }
        
        return this.makeRequest(
            url,
            "DELETE",
            {},
            headers
        );
    }

}

export default VisitorsClient;